import React, {useEffect, useState} from 'react';

import LoadingScreen from 'components/common/LoadingScreen';
import { useForm } from 'react-hook-form';
import {useMutation, useQuery, useQueryClient} from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';

import { login } from 'apis/auth';
import { setCookie} from 'config/cookies';
import { USER_NAME,} from 'constants/Main';
import {AUTH_TENANT_INFO_KEY, AUTH_USER_INFO_KEY} from 'constants/QueryKey';
import useWindowDimensions from 'hooks/useWindowDimensions';

import helperService from '../../services/helperService';

const Login = () => {
  const {alert} = helperService();
  const {screenWidth} = useWindowDimensions();
  const queryClient = useQueryClient();
  const { register, handleSubmit } = useForm();
  const [username, setUsername] = useState('');
  const location = useLocation();
  const tenant = location.pathname.split('/')[1];
  const history = useHistory();
  const mutation = useMutation(params => login(params));
  const [ isFetchUser, setIsFetchUser ] = React.useState(false);
  useQuery(AUTH_USER_INFO_KEY, () => login({username: username}), { suspense: false, enabled: isFetchUser });

  const tenantInfo = queryClient.getQueryData([AUTH_TENANT_INFO_KEY, tenant]);

  const { from } = location.state || { from: { pathname: `/${tenant}` } };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(onLogin)();
    }
  };

  const onChangeUsername = (value) => {
    setUsername(value);
  };

  const onLogin = (dataForm) => {
    if (!dataForm.username) {
      alert('warning', 'Vui lòng nhập Số điện thoại');
    } else {
      mutation.mutate({
        ...dataForm
      }, {
        onSuccess: async ({ meta: { message, status_code } }) => {
          if (status_code !== 0) {
            alert('error', message);
          } else {
            setCookie(USER_NAME, dataForm.username, 86400);
            await setIsFetchUser(true);
            await history.replace(from);
            alert('success', message);
          }
        },
        onError: () => {
          alert('error', 'Đã xảy ra lỗi, vui lòng thử lại sau');
        }
      });
    }
  };

  useEffect(() => {
    document.title = 'Đăng nhập';
  }, []);

  return (
    <>
      { mutation.isLoading && <LoadingScreen /> }
      <div
        className="h-screen w-full flex justify-center"
        style={ {
          backgroundImage: tenantInfo ? tenantInfo.meta.status_code !== 0 ?  'rgba(229, 231, 235,1)' :
            screenWidth > 768 ? tenantInfo.data.theme_setting.login_theme ? `url(${tenantInfo.data.theme_setting.login_theme })` : 'rgba(229, 231, 235,1)' :
              tenantInfo.data.theme_setting.login_theme_mobile ? `url(${tenantInfo.data.theme_setting.login_theme_mobile})` :
                tenantInfo.data.theme_setting.login_theme ? `url(${tenantInfo.data.theme_setting.login_theme})` : 'rgba(229, 231, 235,1)' : 'rgba(229, 231, 235,1)',
          width: '100%',
          backgroundSize: 'cover'
        } }>
        <div className="w-full flex flex-col items-center pt-12 md:pt-32 px-2 relative">
          {
            tenantInfo ? tenantInfo.meta.status_code !== 0 ? null :
              tenantInfo.data.theme_setting.logo_url ?
                <img src={ tenantInfo.data.theme_setting.logo_url  } className='w-200' alt='logo'/> :
                null : null
          }
          <div className="px-6 md:px-10 flex flex-col mt-28 md:mt-40 border-5 absolute bottom-20 mx-2 md:bottom-48"
            style={ {backgroundColor: 'rgba(0,0,0,0.8)', boxShadow: '5px 8px 10px #131313CC'} }>
            <div className="bg-transparent py-8">
              <p className="text-lg text-center text-white">ĐĂNG NHẬP HỆ THỐNG</p>
              <p className='text-lg text-center text-white'>BOOKING ONLINE</p>
              <div className="relative my-4 flex items-center">
                <input
                  type="text"
                  name="username"
                  onChange={ (e) => onChangeUsername(e.target.value) }
                  ref={ register }
                  onKeyDown={ handleKeyDown }
                  placeholder="Số diện thoại"
                  className="px-3 p-1.5 border font-display rounded-lg w-full"
                />
              </div>
              <div className="btn cursor-pointer h-20-important font-15 font-bold mb-4 text-white"
                style={ {backgroundColor: tenantInfo ? tenantInfo.meta.status_code !== 0 ?
                  'rgba(51,192,114,255)' : tenantInfo.data.theme_setting.background_color ?
                    tenantInfo.data.theme_setting.background_color : 'rgba(51,192,114,255)' : 'rgba(51,192,114,255)' } }
                onClick={ handleSubmit(onLogin) }>
                Đăng nhập
              </div>
              <div className="w-full text-white text-center">
                <p>{  tenantInfo ? tenantInfo.meta.status_code !== 0 ?
                  'Quý khách sử dụng số điện thoại đã đăng ký để đăng nhập hệ thống' :
                  tenantInfo.data.theme_setting.title_login ? tenantInfo.data.theme_setting.title_login :
                    'Quý khách sử dụng số điện thoại đã đăng ký để đăng nhập hệ thống':
                  'Quý khách sử dụng số điện thoại đã đăng ký để đăng nhập hệ thống'
                } </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
